/** Screen-Pop für eingehende Anrufe. Gilt nur für das angemeldete Benutzerkonto. */
import api from '@/lib/axios';

export const INCOMING_CALLS_EVENT = 'incoming-calls-changed';

function readUser() {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function incomingCallsEnabled() {
  const user = readUser();
  if (!user) return true;
  return user.incoming_calls !== false;
}

function writeEnabled(on) {
  const user = readUser();
  if (user) {
    user.incoming_calls = !!on;
    localStorage.setItem('user', JSON.stringify(user));
  }
  window.dispatchEvent(new CustomEvent(INCOMING_CALLS_EVENT, { detail: !!on }));
}

export function publishIncomingCalls(user) {
  const next = !user || user.incoming_calls !== false;
  window.dispatchEvent(new CustomEvent(INCOMING_CALLS_EVENT, { detail: next }));
  return next;
}

export async function setIncomingCallsEnabled(on) {
  const previous = incomingCallsEnabled();
  writeEnabled(on);
  try {
    await api.put('/auth/me/preferences', { incoming_calls: !!on });
  } catch (err) {
    writeEnabled(previous);
    throw err;
  }
  return !!on;
}
